import { useTranslation } from "react-i18next";

import { useResellerRecommendations } from "../../apis";
import { RecommendationStrip } from "../../components";

interface ResellerFeedPreviewProps {
  resellerId: string;
}

/** What the mobile app's feed would show this reseller — the fastest answer to
 * "why is this reseller seeing that?" without reading logs. */
const ResellerFeedPreview = ({ resellerId }: ResellerFeedPreviewProps) => {
  const { t } = useTranslation();

  const { recommendations, isLoading } = useResellerRecommendations(resellerId);

  return (
    <RecommendationStrip
      recommendations={recommendations}
      isLoading={isLoading}
      note={t(
        "Admin QA preview — seeded from this reseller's orders, wishlist and product views."
      )}
      emptyText={t(
        "Nothing yet — this reseller has no orders, wishlist or views to seed from."
      )}
    />
  );
};

export default ResellerFeedPreview;
